module.exports = __webpack_public_path__ + "img/pumping-activities-circle.822e4dbd.png";